import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { Client } from "../types/Client";
import { env } from "../utils/env";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

const fetchClient = (authHeader: string, id: number) => () =>
  axios.get<Client>(`${env.verifyServiceUrl}common/tenant/${id}`, {
    headers: {
      Authorization: authHeader,
    },
  });
export const useClientDetails = (id: number) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();
  return useQuery(["clientDetails", id], fetchClient(authHeader, id), {
    enabled: typeof id === "number",
    retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
      if(err.request.status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    }
  });
};
